// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { IndicatorsQuoteModule } from './app.module';
bootstrapAppModule(IndicatorsQuoteModule);
